import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigService } from '../../../../infrastructure/services/config.service';
import { LoaderService } from '../../../../infrastructure/services/loader.service';
import { AlertService, GrowlType } from '../../../../infrastructure/services/alert.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sx-importar.initializer',
  templateUrl: './importar.initializer.component.html',
})
export class ImportarInitializerComponent implements OnInit{
  itemOver;
  file: any;
  data: String;
  formData: FormData;
  codSistema = null;

  constructor(private configService: ConfigService,
              private route: ActivatedRoute,
              private alertService: AlertService) { }


  ngOnInit() {
    this.route.params.subscribe(params => {
      this.codSistema = params['codsistema'];
    });
  }

  /**
  * Abre el File Chooser (File Dialog)
  */
  openFileDialog() {
    $('#fileLoader').click();
  }

  onFileChange(event) {
    const seleccionoUnaImagen = event.target.files && event.target.files.length > 0;
    if (seleccionoUnaImagen) {
      const reader = new FileReader();
      const file = event.target.files[0];
      this.formData = new FormData();
      this.formData.append('configFile', file, file.name);
    }
  }

  importConfig() {
    if (this.formData != null) {
      this.configService.postInitializerImport(this.formData, this.codSistema)
      .then(data => {
          this.alertService.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'IMPORTACION_EXITOSA',
          });
      });

    } else {
      this.alertService.showGrowl({
        type: GrowlType.WARNING,
        body: 'SOC_FE_0002_MUST_SELECT_A_FILE'
      });
    }

  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/initializer/importar/importar.initializer.component.ts